import { computed, Injectable, Signal } from "@angular/core";
import { UserModel } from "@m481/mp-sdk-ng";
import { IListDataResponse } from "@m481/mp-sdk-ng/lib/models/reponses/list-data.response";
import { Observable, of } from "rxjs";

import { AppConstants } from "@mp/app.constants";
import { UserEntity, UserEntityHelper } from "@mp/common/entities/user.entity";
import { BaseStoreService } from "./base-store.service";

@Injectable({
    providedIn: "root"
})
export class UserStoreService extends BaseStoreService<UserEntity, UserModel> {
    constructor() {
        super({
            storageKey: AppConstants.StorageKeys.STORE.USER
        });
        this.init();
    }

    /*
     * Selectors
     */

    public selectTeamUsers(teamId: string): Signal<Array<UserEntity>> {
        return computed(() => this.entities().filter(user => !AppConstants.IGNORED_USER_NAMES.includes(user.username) && (user.teamsAdmin?.includes(teamId) || user.teamsMember?.includes(teamId))));
    }

    /*
     * Base store service SDK methods implementation
     */

    protected mapEntityToModel(entity: UserEntity): UserModel {
        return UserEntityHelper.toModel(entity);
    }

    protected mapModelToEntity(model: UserModel): UserEntity {
        return UserEntityHelper.fromModel(model);
    }

    protected sdkGet$(): Observable<IListDataResponse<UserModel>> {
        return this.mpSdkService.getUsers();
    }

    protected sdkCreate$(model: UserModel): Observable<UserModel> {
        //Not yet implemented in sdk
        return of(model);
    }

    protected sdkUpdate$(model: UserModel): Observable<UserModel> {
        //Not yet implemented in sdk
        return of(model);
    }

    protected sdkDelete$(id: string): Observable<boolean> {
        //Not yet implemented in sdk
        return of(true);
    }
}
